"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getField = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _MediaLibrary = _interopRequireDefault(require("./MediaLibrary"));

var _LinkSelector = _interopRequireDefault(require("./LinkSelector"));

var _Caption = _interopRequireDefault(require("./Caption"));

var _Text = _interopRequireDefault(require("./editorFields/Text"));

var _Wysiwyg = _interopRequireDefault(require("./editorFields/Wysiwyg"));

var _FilePicker = _interopRequireDefault(require("./editorFields/FilePicker"));

var _Menu = _interopRequireDefault(require("./editorFields/Menu"));

var _Repeater = _interopRequireDefault(require("./editorFields/Repeater"));

var _Link = _interopRequireDefault(require("./editorFields/Link"));

var _Select = _interopRequireDefault(require("./editorFields/Select"));

var _Checkbox = _interopRequireDefault(require("./editorFields/Checkbox"));

var _Radio = _interopRequireDefault(require("./editorFields/Radio"));

var _Number = _interopRequireDefault(require("./editorFields/Number"));

var _FlexibleContent = _interopRequireDefault(require("./editorFields/FlexibleContent"));

var _DatePicker = _interopRequireDefault(require("./editorFields/DatePicker"));

var _Group = _interopRequireDefault(require("./editorFields/Group"));

var _Gallery = _interopRequireDefault(require("./editorFields/Gallery"));

var _GoogleMap = _interopRequireDefault(require("./editorFields/GoogleMap"));

var _ColorPicker = _interopRequireDefault(require("./editorFields/ColorPicker"));

var _store = require("../store");

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getField = function getField(_ref) {
  var index = _ref.index,
      field = _ref.field,
      site = _ref.site,
      onChangeElement = _ref.onChangeElement,
      dispatch = _ref.dispatch,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level;
  var component;

  switch (field.type) {
    case 'group':
      component = /*#__PURE__*/_react.default.createElement(_Group.default, (0, _extends2.default)({}, field, {
        site: site,
        dispatch: dispatch,
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'text':
      component = /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(e) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: e.target.value
          }));
        }
      }));
      break;

    case 'color_picker':
      component = /*#__PURE__*/_react.default.createElement(_ColorPicker.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'wysiwyg':
      component = /*#__PURE__*/_react.default.createElement(_Wysiwyg.default, (0, _extends2.default)({}, field, {
        index: index,
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'number':
      component = /*#__PURE__*/_react.default.createElement(_Number.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'date_picker':
      component = /*#__PURE__*/_react.default.createElement(_DatePicker.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'link':
      component = /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, field, {
        onRemove: function onRemove() {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: null
          }));
        },
        onClick: function onClick() {
          return dispatch({
            type: "SET_DIALOG",
            payload: {
              open: true,
              title: 'Link',
              component: /*#__PURE__*/_react.default.createElement(_LinkSelector.default, (0, _extends2.default)({}, field, {
                onChange: function onChange(value) {
                  return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
                    value: value
                  }));
                }
              })),
              width: 500
            }
          });
        }
      }));
      break;

    case 'select':
      component = /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'checkbox':
      component = /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'radio':
      component = /*#__PURE__*/_react.default.createElement(_Radio.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'repeater':
      component = /*#__PURE__*/_react.default.createElement(_Repeater.default, (0, _extends2.default)({}, field, {
        site: site,
        dispatch: dispatch,
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'flexible_content':
      component = /*#__PURE__*/_react.default.createElement(_FlexibleContent.default, (0, _extends2.default)({}, field, {
        site: site,
        dispatch: dispatch,
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'image':
      component = /*#__PURE__*/_react.default.createElement(_FilePicker.default, (0, _extends2.default)({}, field, {
        onRemove: function onRemove() {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: null
          }));
        },
        onClick: function onClick() {
          return dispatch({
            type: "SET_DIALOG",
            payload: {
              open: true,
              component: /*#__PURE__*/_react.default.createElement(_MediaLibrary.default, {
                onSelect: function onSelect(value) {
                  return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
                    value: value
                  }));
                },
                allow: ['image']
              }),
              width: 1024
            }
          });
        }
      }));
      break;

    case 'gallery':
      component = /*#__PURE__*/_react.default.createElement(_Gallery.default, (0, _extends2.default)({}, field, {
        dispatch: dispatch,
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'file':
      component = /*#__PURE__*/_react.default.createElement(_FilePicker.default, (0, _extends2.default)({}, field, {
        onRemove: function onRemove() {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: null
          }));
        },
        onClick: function onClick() {
          return dispatch({
            type: "SET_DIALOG",
            payload: {
              open: true,
              component: /*#__PURE__*/_react.default.createElement(_MediaLibrary.default, {
                onSelect: function onSelect(value) {
                  return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
                    value: value
                  }));
                }
              }),
              width: 1024
            }
          });
        }
      }));
      break;

    case 'menu':
      component = /*#__PURE__*/_react.default.createElement(_Menu.default, (0, _extends2.default)({}, field, {
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    case 'google_map':
      component = /*#__PURE__*/_react.default.createElement(_GoogleMap.default, (0, _extends2.default)({}, field, {
        site: site,
        onChange: function onChange(value) {
          return onChangeElement(_objectSpread(_objectSpread({}, field), {}, {
            value: value
          }));
        }
      }));
      break;

    default:
  }

  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: field.id
  }, field.type === 'repeater' || field.type === 'flexible_content' || field.type === 'group' ? component : /*#__PURE__*/_react.default.createElement(FieldContainer, {
    level: level + 1
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: field.label || field.id
  }), field.instructions && /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: "secondary",
    children: field.instructions
  }), component)));
};

exports.getField = getField;

var EditorFields = function EditorFields(props) {
  var fields = props.fields,
      onChangeElement = props.onChangeElement;

  var _ref3 = (0, _store.useStore)(),
      _ref4 = _slicedToArray(_ref3, 2),
      site = _ref4[0].editorState.site,
      dispatch = _ref4[1];

  return /*#__PURE__*/_react.default.createElement(Container, null, fields && fields.filter(function (field) {
    return !!field;
  }).map(function (field) {
    return getField({
      field: field,
      site: site,
      onChangeElement: onChangeElement,
      dispatch: dispatch,
      level: 0
    });
  }));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  > .ant-collapse {\n    border: none;\n    border-bottom: 1px solid #d9d9d9;\n  }\n\n  .ant-collapse-header {\n    padding: 12px 16px 12px 30px;\n  }\n"])));

var FieldContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 8px ", ";\n"])), function (_ref2) {
  var level = _ref2.level;
  return level === 1 ? '16px' : '4px';
});

var _default = EditorFields;
exports.default = _default;